import { CredentialModel } from '../models/credentials';
import { Injectable } from '@angular/core';
import { ConfigData } from '../interfaces/config-data';
import { NgxRolesService, NgxPermissionsService } from 'ngx-permissions';
import { from, BehaviorSubject, Subject } from 'rxjs';
import { mergeMap, filter } from 'rxjs/operators';
import { TokenStorage } from '../auth/token-storage.service';
// import { AuthenticationService } from '../auth/authentication.service';

@Injectable()
export class CredentialService implements ConfigData {
	public credentialModel: CredentialModel;
	public onCredentialUpdated$: BehaviorSubject<CredentialModel>;

	constructor(
		private roleService: NgxRolesService,
		private permService: NgxPermissionsService,
		private tokenStorage: TokenStorage,
		// private authService: AuthenticationService,
	) {
		// set initial permission model
		this.credentialModel = new CredentialModel();
		this.onCredentialUpdated$ = new BehaviorSubject(this.credentialModel);

		// this.authService.getUserRoles().subscribe(roles => {
		// 	console.log('roles iniciales--->');
		// 	console.log(roles);
		// 	this.setCurrrentUserRoles(roles);
		// });

		this.tokenStorage.getUserRoles().subscribe(roles => {
			this.setCurrrentUserRoles(roles);
		});

		// subscribe to credential changed, eg. after login response
		// this.authService.onCredentialUpdated$
		// 	.pipe(mergeMap(accessData => this.authService.getUserRoles()))
		// 	.subscribe(roles => this.setCurrrentUserRoles(roles));

		// subscribe to credendial data observable
		this.onCredentialUpdated$.subscribe(cred => {
			const permissions = Object.keys(cred.permissions).map((key) => {
				return cred.permissions[key];
			});
			// load default permission list
			// console.log(permissions);
			this.permService.loadPermissions(permissions, (permissionName, permissionStore) => !!permissionStore[permissionName]);

			// merge current user roles
			const roles = Object.assign({}, this.credentialModel.currentUserRoles, {
			
				// default user role is GUEST
				GUEST: () => {
					// return this.authService.isAuthorized().toPromise();
				}
			});
			// add to role service
			// console.log('roles updated--->');
			// console.log(roles);
			 this.roleService.addRoles(roles);
		
		});
	}

	/**
	 * Set AclModel and fire off event that all subscribers will listen to
	 * @param aclModel
	 */
	setModel(credModel: CredentialModel): any {
		credModel = Object.assign({}, this.credentialModel, credModel);
		this.onCredentialUpdated$.next(credModel);
	}

	setCurrrentUserRoles(roles: any): any {
		// update roles if the credential data has roles
		if (roles != null) {
			this.credentialModel.currentUserRoles = {};
			roles.forEach(role => {
				// console.log( role);
				this.credentialModel.currentUserRoles[role] = this.credentialModel.permissions[role];
				// console.log(this.credentialModel.permissions[role]);
			});
			// set updated acl model back to service
			// console.log(this.credentialModel);
			this.setModel(this.credentialModel);
		}
	}

	
	setUserData(userData: any): any {
		// update roles if the credential data has roles
		if (userData != null) {
			this.credentialModel.userData = userData;
			// set updated acl model back to service
			// console.log(this.credentialModel.userData);
		
		}
	}
	getUserData(): any {
		return	this.tokenStorage.getUserData();
	}

}
